export default __webpack_public_path__ + "static/media/ChaseBank.6153fb17.svg";